export default __webpack_public_path__ + "static/media/eb-ultra-blk-1.44e2e70e.png";